module.exports = __webpack_public_path__ + "media/images/regions/Tillaberi-0670f50e5db5b192ff146497f99fe648.png";